import axios from 'axios';
import {PUBLIC_API_URL} from './settings';
import * as T from "../utils/types";
import * as U from "../utils/utils";
import {
    CreationsGETRequest,
    CreationsGETResponse,
    CreationYearsStatsGETRequest,
    CreationYearsStatsGETResponse,
    FcltDeptStat_Creation,
    FuzzySearchResearcherID
} from '../utils-creation/types';


export const public_axios = axios.create({
    baseURL: PUBLIC_API_URL
});

export const getFcltDepts = async (): Promise<T.FcltDeptI[]> => {
    const url = 'v2/fcltdept/'
    // console.log('fetching data from: ', url);
    const {data} = await public_axios.get(url);
    return data;
};

export const rFcltDeptStat_AltTrending = async () : Promise<T.FcltDeptStat_Pub> => {
    // GET http://localhost/api/public/v2/altmetric/trending/?stat=FcltDept
    let url = "v2/altmetric/trending/?stat=FcltDept";
    const {data} = await public_axios.get(url);
    return data;
};

export const rFcltDeptStat_Pub = async (
    searchInput: string, 
    keywordType: string, 
    pubYear: number
) : Promise<T.FcltDeptStat_Pub> =>{
    // search stats: http://<host>/api/public/v2/publications/?stat=FcltDept&search=machine%20learning
    // match stats: http://<host>/api/public/v2/publications/?stat=FcltDept&match=greg%20mori
    let url = "v2/publications/?stat=FcltDept";
    if (searchInput !== '') { url += `&${keywordType}=${searchInput}`;
    }
    if (pubYear && pubYear !== -1 ) {
        url += `&date__range=${pubYear}-01-01,${pubYear}-12-31`
    } else if(U.isNull(pubYear)){
        url += `&date__isnull=True`
    }
    const {data} = await public_axios.get(url);
    return data;
};

export const rFcltDeptStat_SmtPub = async (
    searchInput: string, 
    keywordType: string, 
) : Promise<T.FcltDeptStat_GsPub> =>{
    // search stats: http://<host>/api/public/v2/publications/?stat=FcltDept&search=machine%20learning
    // match stats: http://<host>/api/public/v2/publications/?stat=FcltDept&match=greg%20mori
    let url = "v2/summitpublications/?stat=FcltDept";
    if (searchInput !== '') { 
        url += `&${keywordType}=${searchInput}`;
    }
    const {data} = await public_axios.get(url);
    return data;
};

export const rFcltDeptStat_GsPub = async (
    searchInput: string, 
    keywordType: string, 
    pubYear: number
) : Promise<T.FcltDeptStat_GsPub> =>{
    // search stats: http://<host>/api/public/v2/publications/?stat=FcltDept&search=machine%20learning
    // match stats: http://<host>/api/public/v2/publications/?stat=FcltDept&match=greg%20mori
    let url = "v2/gspublications/?stat=FcltDept";
    if (searchInput !== '') { 
        url += `&${keywordType}=${searchInput}`;
    }
    if (pubYear && pubYear !== -1 ) {
        url += `&year=${pubYear}`
    } else if(U.isNull(pubYear)){
        url += `&year__isnull=True`
    }
    const {data} = await public_axios.get(url);
    return data;
};


export const rFcltDeptStat_Rsr = async (
    searchInput: string, 
    keywordType: string, 
    acceptingGraduateStudentChecked: boolean,
    C3IChecked: boolean,
    SDG: number[]
) : Promise<T.FcltDeptStat_Rsr> => {
    // search stats: http://<host>/api/public/v2/researchers/?stat=FcltDept&search=machine%20learning
    // match stats: http://<host>/api/public/v2/researchers/?stat=FcltDept&match=greg%20mori
    let url = "v2/researchers/?stat=FcltDept"
    if (searchInput !== '') {
        url += `&${keywordType}=${searchInput}`;
    }
    if(keywordType==="search"){
        if (acceptingGraduateStudentChecked) {
            url += `&recruitment__accepting_graduate_student=true`;
        }
        if (C3IChecked) {
            url += `&C3I=true`;
        }
    }
    if (SDG) { //when SDG is 0, means do not filter on SDG; all other SDG index is in [1-17]
        url += `&SDG=${SDG}`;
    }
    const {data} = await public_axios.get(url);
    return data;
};

export const rAltTrendingList = async (
    page: number, 
    deptID: number, 
    fcltID: number, 
    sortType: T.altTrendingSortType
):Promise<T.AltTrendingGETResponse>  => {
    let url = `v2/altmetric/trending/?page=${page}&ordering=${sortType}`;
    if (deptID !== -1) {
        url += `&sfu_authors__departments=${deptID}`;
    }
    if (fcltID !== -1) {
        url += `&sfu_authors__departments__faculty=${fcltID}`;
    }
    const { data } = await public_axios.get(url);
    return data;
};

export const rPubList = async (
    searchInput: string, 
    keywordType: T.keywordType, 
    page: number, 
    deptID: number, 
    fcltID: number, 
    year: number,
    sortType: T.pubListSortType
):Promise<T.PublicationsGETResponse>  => {
    let url = `v2/publications/?page=${page}&ordering=${sortType}`;
    if (searchInput !== '') {
        url += `&${keywordType}=${searchInput}`;
    }
    if (deptID !== -1) {
        url += `&sfu_authors__departments=${deptID}`;
    }
    if (fcltID !== -1) {
        url += `&sfu_authors__departments__faculty=${fcltID}`;
    }
    if (year && (year !== -1)) {
        url += `&date__range=${year}-01-01,${year}-12-31`
    } else if (U.isNull(year)) {
        url += `&date__isnull=True`
    }
    const {data} = await public_axios.get(url);
    return data;
};

export const rGsPubList = async (
    searchInput: string, 
    keywordType: T.keywordType, 
    page: number, 
    deptID: number, 
    fcltID: number, 
    year: number,
    sortType: T.gsPubListSortType
):Promise<T.GsPublicationsGETResponse>  => {
    let url = `v2/gspublications/?page=${page}&ordering=${sortType}`;
    if (searchInput !== '') {
        url += `&${keywordType}=${searchInput}`;
    }
    if (deptID !== -1) {
        url += `&sfu_authors__departments=${deptID}`;
    }
    if (fcltID !== -1) {
        url += `&sfu_authors__departments__faculty=${fcltID}`;
    }
    if (year && (year !== -1)) {
        url += `&year=${year}`
    } else if (U.isNull(year)) {
        url += `&year__isnull=True`
    }
    const {data} = await public_axios.get(url);
    return data;
};

export const rSmtPubList = async (
    searchInput: string, 
    keywordType: T.keywordType, 
    page: number, 
    deptID: number, 
    fcltID: number, 
):Promise<T.SmtPublicationsGETResponse>  => {
    let url = `v2/summitpublications/?page=${page}&ordering=-date4sorting`;
    if (searchInput !== '') {
        url += `&${keywordType}=${searchInput}`;
    }
    if (deptID !== -1) {
        url += `&sfu_authors__departments=${deptID}`;
    }
    if (fcltID !== -1) {
        url += `&sfu_authors__departments__faculty=${fcltID}`;
    }
    const {data} = await public_axios.get(url);
    return data;
};

export const rPubList_oneRsr = async (
    randomID: string,
    page: number,
    year: number,
    sortType: T.pubListSortType
):Promise<T.PublicationsGETResponse>  => {
    let url = `v2/publications/?page=${page}&ordering=${sortType}&sfu_authors__random_id=${randomID}`;
    if (year && (year !== -1)) {
        url += `&date__range=${year}-01-01,${year}-12-31`
    } else if (U.isNull(year)) {
        url += `&date__isnull=True`
    }
    const {data} = await public_axios.get(url);


    return data;
};

export const rGsPubList_oneRsr = async (
    randomID: string,
    page: number,
    year: number,
    sortType: T.gsPubListSortType
):Promise<T.GsPublicationsGETResponse>  => {
    let url = `v2/gspublications/?page=${page}&ordering=${sortType}&sfu_authors__random_id=${randomID}`;
    if (year && (year !== -1)) {
        url += `&year=${year}`
    } else if (U.isNull(year)) {
        url += `&year__isnull=True`
    }
    const {data} = await public_axios.get(url);
    return data;
};

export const rSmtPubList_oneRsr = async (
    randomID: string,
    page: number,
):Promise<T.SmtPublicationsGETResponse>  => {
    let url = `v2/summitpublications/?page=${page}&sfu_authors__random_id=${randomID}&ordering=-date4sorting`;
    const {data} = await public_axios.get(url);
    return data;
};

export const rPubYearStat = async (
    searchInput: T.searchInput,
    keywordType: T.keywordType,
    deptID: number,
    fcltID: number
):Promise<T.PublicationYearsGETResponse>  => {
    let url = `v2/publications/?stat=Year`;
    if (searchInput !== '') {
        url += `&${keywordType}=${searchInput}`;
    }
    if (deptID !== -1) {
        url += `&sfu_authors__departments=${deptID}`;
    }
    if (fcltID !== -1) {
        url += `&sfu_authors__departments__faculty=${fcltID}`;
    }
    const {data} = await public_axios.get(url);
    return data;
};

export const rGsPubYearStat = async (
    searchInput: T.searchInput,
    keywordType: T.keywordType,
    deptID: number,
    fcltID: number
):Promise<T.GsPublicationYearsGETResponse>  => {
    let url = `v2/gspublications/?stat=Year`;
    if (searchInput !== '') {
        url += `&${keywordType}=${searchInput}`;
    }
    if (deptID !== -1) {
        url += `&sfu_authors__departments=${deptID}`;
    }
    if (fcltID !== -1) {
        url += `&sfu_authors__departments__faculty=${fcltID}`;
    }
    const {data} = await public_axios.get(url);
    return data;
};

export const rPubYearStat_oneRsr = async (
    randomID: string, 
):Promise<T.PublicationYearsGETResponse>  => {
    let url = `v2/publications/?stat=Year&sfu_authors__random_id=${randomID}`;
    const {data} = await public_axios.get(url);
    return data;
};

export const rGsPubYearStat_oneRsr = async (
    randomID: string, 
):Promise<T.GsPublicationYearsGETResponse>  => {
    let url = `v2/gspublications/?stat=Year&sfu_authors__random_id=${randomID}`;
    const {data} = await public_axios.get(url);
    return data;
};

export const rRsrList = async (
    searchInput: T.searchInput, 
    keywordType: T.keywordType, 
    page: number, 
    deptID: number, 
    fcltID: number, 
    acceptingGraduateStudentChecked: boolean,
    C3IChecked: boolean,
    SDG: number[]
): Promise<T.ResearchersGETResponse> => {
    let url = `v2/researchers/?page=${page}`;
    if (searchInput !== '') {
        url += `&${keywordType}=${searchInput}`;
    }
    if (deptID !== -1) {
        url += `&departments=${deptID}`;
    }
    if (fcltID !== -1) {
        url += `&departments__faculty=${fcltID}`;
    }
    // when `keyword type` is `search`, means search by keywords
    // when it is `match`, means search by researcher's name
    if (keywordType==="search"){ 
        if (acceptingGraduateStudentChecked) {
            url += `&recruitment__accepting_graduate_student=true`;
        }
        if (C3IChecked) {
            url += `&C3I=true`;
        }
    }
    if (SDG) { //when SDG is 0, means do not filter on SDG; all other SDG index is in [1-17]
        url += `&SDG=${SDG}`;
    }
    const {data} = await public_axios.get(url);

    return data;
};

export const rRsr = async ( randomID: string ): Promise<T.Researcher> => {
    let url = `v2/researchers/?random_id=${randomID}`;
    const {data} = await public_axios.get(url);

    const rslt = data.results[0];

    return rslt;
};


export const getStat_SDG = async ({
    searchInput, 
    keywordType, 
    deptID, 
    fcltID, 
    acceptingGraduateStudentChecked,
    C3IChecked,
}: T.SDGStatGETRequest): Promise<T.SDGStatGETResponse> => {
    let url = `v2/researchers/?stat=SDG`;
    if (searchInput !== '') {
        url += `&${keywordType}=${searchInput}`;
    }
    if (deptID !== -1) {
        url += `&departments=${deptID}`;
    }
    if (fcltID !== -1) {
        url += `&departments__faculty=${fcltID}`;
    }
    // when `keyword type` is `search`, means search by keywords
    // when it is `match`, means search by researcher's name
    if (keywordType==="search"){ 
        if (acceptingGraduateStudentChecked) {
            url += `&recruitment__accepting_graduate_student=true`;
        }
        if (C3IChecked) {
            url += `&C3I=true`;
        }
    }
    const {data} = await public_axios.get(url);
    return data;
};

export const getCreationsList = async ({
    randomID,
    page,
    year,
    keywordType,
    searchInput,
    facultyID,
    departmentID,
    // sortType,
}: CreationsGETRequest): Promise<CreationsGETResponse> => {
    let url = `v2/creations/?ordering=-premiere_year&page=${page}`;
    if (randomID) {
        url += `&researchers__researcher__random_id=${randomID}`;
    }
    if (keywordType && searchInput) {
        url += `&${keywordType}=${searchInput}`;
    }
    if (facultyID && facultyID !== -1) {
        url += `&researchers__researcher__departments__faculty=${facultyID}`;
    }
    if (departmentID && departmentID !== -1) {
        url += `&researchers__researcher__departments=${departmentID}`;
    }
    if (year && year !== -1) {
        url += `&premiere_year=${year}`;
    }
    const { data } = await public_axios.get(url);
    return data;
}

export const getCreationYearsStats = async ({
    randomID,
    keywordType,
    searchInput,
    facultyID,
    departmentID,
}: CreationYearsStatsGETRequest): Promise<CreationYearsStatsGETResponse> => {
    let url = 'v2/creations/?stats=Year';
    if (randomID) {
        url += `&researchers__researcher__random_id=${randomID}`;
    }
    if (keywordType && searchInput) {
        url += `&${keywordType}=${searchInput}`;
    }
    if (facultyID && facultyID !== -1) {
        url += `&researchers__researcher__departments__faculty=${facultyID}`;
    }
    if (departmentID && departmentID !== -1) {
        url += `&researchers__researcher__departments=${departmentID}`;
    }
    const { data } = await public_axios.get(url);
    return data;
}

export const getFuzzySearchResearchersID = async (keyword: string): Promise<FuzzySearchResearcherID[]> => {
    const url = `v2/researchers-id/?keyword=${keyword}`;
    const { data } = await public_axios.get(url);
    return data;
}

export const rFcltDeptStat_Creation = async (
  searchInput: string,
  keywordType: string,
  premiereYear: number
): Promise<FcltDeptStat_Creation> => {
  let url = "v2/creations/?stats=FcltDept";
  if (keywordType && searchInput) {
    url += `&${keywordType}=${searchInput}`;
  }
  if (premiereYear !== -1) {
    url += `&premiere_year=${premiereYear}`;
  }
  const { data } = await public_axios.get(url);
  return data;
};
